import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import StoreS3 from '../../util/StoreS3.jsx';
import ListWorksetItems from "./ListWorksetItems.jsx";
import {IndentedContentWrapper} from '../../util/Styles.jsx';
import DataRow from './DataRow.jsx';

export class WorksetDetail extends Component {

    static propTypes = {
        workset: PropTypes.object.isRequired
    }

    state = {
        in_item_add: false
    };

    componentDidMount() {
    }

    confirm_field_value_edit = (edit_field_name, new_value) => {
        const workset = this.props.workset;
        workset["updated"] = moment().format();
        workset[edit_field_name] = new_value;
        StoreS3.put_file(workset.path, JSON.stringify(workset, undefined, 2));
    }

    render() {
        return <IndentedContentWrapper>
            <DataRow
                item_data={this.props.workset}
                name={"index"}
                can_edit={true}
                update_item={new_value => this.confirm_field_value_edit ("index", new_value)}
            />
            <DataRow
                item_data={this.props.workset}
                name={"value"}
                can_edit={true}
                field_type={"textarea"}
                update_item={new_value => this.confirm_field_value_edit ("value", new_value)}
            />
            <ListWorksetItems workset={this.props.workset}/>
        </IndentedContentWrapper>
    }
}

export default WorksetDetail;

